import { render, staticRenderFns } from "./SelectFornecedor.vue?vue&type=template&id=02f450f8&scoped=true"
import script from "./SelectFornecedor.vue?vue&type=script&lang=js"
export * from "./SelectFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f450f8",
  null
  
)

export default component.exports